import $ from "jquery";
import React, { Suspense, useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import UserBasicInfoContext from '../../../components/Context/UserBasicInfoContext';
import VoucherCategory from './VoucherCategory/VoucherCategory';
import CategoryList from "./BusinessCategory/CategoryList";

import { SUPER_ADMIN } from "../ConstRole/ConstRole";
import Mou from "./UnitOfMeasure/Mou";


const Category = () => {
    const [currentTab, setCurrentTab] = useState("BusinessCategory");
    const userProfile = useContext(UserBasicInfoContext);

    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }


    
    const { state } = useLocation();
    useEffect(() => {

        if ((state?.tab !== null && state?.tab !== undefined && state?.tab !== "")) {
            if (state?.tab === "VoucherCategory") {
                $(".tablinks").eq(1).trigger("click");
            }

            if (state?.tab === "Mou") {
                $(".tablinks").eq(2).trigger("click");
            }
        }

    }, [state]);


    if (userProfile.user_type !==  SUPER_ADMIN) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }



    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20 ">

            
        {/* TAB SWITCHER */}
        <div className="tab w-full">
            <button className="tablinks current" onClick={(event) => handleTab("BusinessCategory", event)}>Shop Business Category</button>
            <button className="tablinks" onClick={(event) => handleTab("VoucherCategory", event)}>Voucher Category</button>
            <button className="tablinks" onClick={(event) => handleTab("UnitOfMeasure", event)}>Unit of Measure</button>
        </div>

        <div className='tabcontentbody py-3 px-0'>
            <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px", paddingRight: "0px" }}>
                <Suspense fallback="Loading...">

                    {(() => {
                        switch (currentTab) {
                            case "BusinessCategory":
                                return <CategoryList />;
                            case "VoucherCategory":
                                return <VoucherCategory />;
                            case "UnitOfMeasure":
                                return <Mou />;
                            default:
                                return <>No page found</>;
                        }
                    })()}

                </Suspense>
            </div>
        </div>

                


            <style>{`
                .custom-scroll-auto { 
                    overflow-x: hidden;
                }

                .tab button:hover::after, .tab button.current::after { 
                    width: 120% !important;
                    margin-left: -10% !important;
                }
                `}</style>


        </div>
    );
};

export default Category;